import * as server from '../../../Axios'

export const getSalidas = async q => {
  return await server
    .getSalidasDash(q)
    .then(response => ({ data: response.data }))
    .catch(error => ({ error: error }))
}
